import * as ng from 'angular';

import { Prize } from '../shared/prize.model';
import { UtilsService, defaultDateInputFormat } from '../../../shared';

export class PrizeEditorController implements ng.IController {
   static $inject = ['utils', 'dialogs'];

   constructor(private utils: UtilsService, private dialogs) { }

   prize:Prize;
   eventId:number;
   isPrizeStationRequired: boolean;

   resolve:{prize:Prize, eventId:number, isPrizeStationRequired:boolean};
   close:{({$value:any}):void};
   dismiss:{({$value:any}):void};

   get availableStart() {
      if (this.prize.availableStart) {
         let m = this.utils.toServerMoment(this.prize.availableStart);
         return m.format(defaultDateInputFormat);
      }
   }

   set availableStart(val:string) {
      this.prize.availableStart = this.utils.toServerDateTime(val);
   }

   get availableEnd() {
      if (this.prize.availableEnd) {
         let m = this.utils.toServerMoment(this.prize.availableEnd);
         return m.format(defaultDateInputFormat);
      }
   }

   set availableEnd(val:string) {
      this.prize.availableEnd = this.utils.toServerDateTime(val);
   }

   $onInit() {
      this.prize = ng.copy(this.resolve.prize);
      this.eventId = this.resolve.eventId;
      this.isPrizeStationRequired = this.resolve.isPrizeStationRequired;
      if (this.prize.unlimited && this.prize.periodic) {
         var message =
            "'Available Offline' and 'Force Giveaway' were both checked. This is no longer valid. Both have been deselected. Continue to update this prize with your new selection.";

         this.dialogs.alert(message).then(() => {
            this.prize.unlimited = false;
            this.prize.periodic = false;
         });
      }
   }

   clickAvailableOffline() {
      if (!this.prize.unlimited && this.prize.periodic) {
         this.prize.periodic = false;
      }
   }

   clickPeriodic() {
      if (!this.prize.periodic && this.prize.unlimited) {
         this.prize.unlimited = false;
      }
   }

   cancel() {
      this.dismiss({$value: 'cancel'});
   }

   save(form:ng.IFormController) {
      form.$setSubmitted();
      if (form.$valid) {
         this.close({$value: this.prize});
      }
   }
}

ng.module('e360').component('prizeEditor', {
   templateUrl: require('./prize-editor.html'),
   controller: PrizeEditorController,
   bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&'
   }
});
